import React from "react"
import { Box } from "@mui/material"
import { AppFormGrid, AppFormSection } from "@components"
import { ReportFormDrawer } from "Pages/ReportsAlerts/Reports/@components"
import { ReportNameSection } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import {
	ReportFormDrawerExportFiltersSection,
	ReportFormDrawerFrequencySection,
	ReportFormDrawerSearchConfigSection,
	ReportFormDrawerSitesOfficesSection
} from "Pages/ReportsAlerts/Reports/Extra/Page/Drawer/Sections"

export default function ReportExtraFormDrawer() {

	return <ReportFormDrawer>
		<AppFormSection icon="file-lines" title="Report">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 6' }} data-tour-id="tour-report-name">
					<ReportNameSection/>
				</Box>
			</AppFormGrid>
		</AppFormSection>
		<ReportFormDrawerSitesOfficesSection/>
		<ReportFormDrawerSearchConfigSection/>
		<ReportFormDrawerExportFiltersSection/>
		<ReportFormDrawerFrequencySection/>
	</ReportFormDrawer>
}
